<script>
import { required } from 'vuelidate/lib/validators'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

import axios from 'axios'

export default {
  page: {
    title: 'Credentials breaches VIP',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: 'Credentials breaches VIP',
      category: 'List',
      url: '/domains/credentials/breaches?db=emails&collection=credential_breaches_vip&altorder=BreachDate&direction=desc',
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Credentials breaches checks',
          active: true,
        },
      ],
      isBusy: false,
      tableData: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 50, 100],
      filter: '',
      sortBy: 'datetime',
      sortDesc: true,
      fields: [
        { key: 'datetime', field: 'datetime', label: 'Checks', thClass: 'incident-status', sortable: true, visible: true },
        { key: 'email', field: 'email', label: 'Email', sortable: true, visible: true },
        { key: 'title', field: 'title', label: 'Title', sortable: true, visible: true },
        { key: 'breachdate', field: 'breachdate', label: 'Breach Date', sortable: true, visible: true },
        { key: 'modifieddate', field: 'modifieddate', label: 'Modified Date', sortable: true, visible: true },
      ],
    }
  },
  validations: {
    event: {
      title: { required },
      category: { required },
    },
  },
  computed: {
    rows() {
      return this.totalRows
    },
    displayedRange() {
      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(start + this.perPage - 1, this.totalRows);
      return { start, end };
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData(src = '') {
      let that = this
      that.isBusy = true
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      const searchType = this.searchType
      const countURL = (src.length < 1) ? `${baseURL}${that.url}&count=yes` : `${baseURL}${that.url}&${searchType}=${src}&count=yes`

      axios.get(countURL)
        .then((response) => {
          that.totalRows = parseInt(response.data)
        })
        .catch(function () {

        })
      const dataURL = `${baseURL}${that.url}&page=${that.currentPage}&page_size=${that.perPage}&limit=${that.perPage}`;

      axios.get(dataURL).then((response) => {
        if (response.status === 200) {
          that.tableData = response.data.map(function (entry) {
            return {
              datetime: new Date(entry.Datetime).toLocaleString(),
              email: entry.email,
              title: entry.Title,
              breachdate: new Date(entry.BreachDate).toLocaleString(),
              modifieddate: new Date(entry.ModifiedDate).toLocaleString(),
            }
          })
        }
        that.isBusy = false
      })
        .catch(function () {

        })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <span>
          Showing {{ displayedRange.start }} to {{ displayedRange.end }} of {{ totalRows }}
        </span>
      </div>
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-table :items="tableData" :fields="fields" :busy="isBusy" responsive="sm" :per-page="0"
              :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :total-rows="totalRows"
              :pagination-options="{
                enabled: true,
              }">
              <template v-slot:table-busy>
                <div class="text-center">
                  <br><br>
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>&nbsp;&nbsp;Loading...</strong>
                </div>
              </template>
            </b-table>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"
                      @change="loadData"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                      @input="loadData"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
